// extracted by mini-css-extract-plugin
var _1 = "ProviderForm-moduleformBody__oLyJl";
export { _1 as "formBody" }
